module.exports = __webpack_public_path__ + "img/lg_ring_r_l_1_1@3x.7cb88e72.png";